import { lazy } from "react";
const OrderManagement = lazy(() => import("@/pages/orderManagement/page"));
const OrderDetailPage = lazy(
  () => import("@/pages/orderManagement/orderDetail/page"),
);

const orderRoute = [
  {
    path: "/orderManagement",
    name: "采购订单管理",
    component: OrderManagement,
    hideBreadcrumb: true,
    children: [
      {
        path: "/orderManagement/detail/:id",
        name: "订单详情",
        component: OrderDetailPage,
      },
    ],
  },
];
export default orderRoute;
